import React from "react";
import { useTranslation } from "react-i18next";
import { Wordmark } from "./ui.jsx";
import { useLocaleNav } from "../lib/useLocaleNav.js";

const legalLink = {
  color: "var(--muted)",
  textDecoration: "none",
  fontSize: 13.5,
  cursor: "pointer"
};

function currentLocale(i18n) {
  return (i18n && i18n.language) || "en";
}

export default function Footer() {
  const { t, i18n } = useTranslation();
  const go = useLocaleNav();

  const legalLinks = [
    { label: t("footer.privacy"),         route: "privacy" },
    { label: t("footer.termsOfUse"),      route: "terms" },
    { label: t("footer.termsOfSale"),     route: "terms-of-sale" },
    { label: t("footer.returnPolicy"),    route: "return-policy" },
    { label: t("footer.cookiePolicy"),    route: "cookie-policy" },
    { label: t("footer.cookieSettings"),  action: "cookie-settings" }
  ];

  const cols = [
    {
      title: t("footer.groupProduct"),
      items: [
        { l: t("nav.how"),       t: "how" },
        { l: t("nav.pricing"),   t: "pricing" },
        { l: t("nav.gbpIntegration"), t: "integrations/google-business-profile" }
      ]
    },
    {
      title: t("footer.groupProof"),
      items: [
        { l: t("nav.results"),   t: "results" },
        { l: t("nav.fairHospitality"), t: "fair-hospitality" },
        { l: t("nav.contact"),   t: "contact" }
      ]
    }
  ];

  return (
    <footer style={{ borderTop: "1px solid var(--line)", background: "var(--bg)", paddingTop: 96, paddingBottom: 40 }}>
      <div className="container">
        <div style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1.6fr) repeat(2, minmax(0, 1fr)) minmax(0, 1.4fr)",
          gap: 64, alignItems: "flex-start"
        }} className="footer-grid">
          <div>
            <Wordmark size={26} />
            <p style={{ color: "var(--muted)", fontSize: 15.5, lineHeight: 1.65, marginTop: 24, maxWidth: 340 }}>
              {t("footer.blurb")}
            </p>
            <div className="tagline" style={{ marginTop: 24 }}>{t("common.tagline")}</div>
          </div>

          {cols.map(c => (
            <div key={c.title}>
              <div style={{ fontSize: 11.5, fontWeight: 600, letterSpacing: ".16em", textTransform: "uppercase", color: "var(--ink-2)", marginBottom: 20, fontFamily: "Inter, sans-serif" }}>{c.title}</div>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 14 }}>
                {c.items.map(item => (
                  <li key={item.l}>
                    <a href={"#"} onClick={(e) => { e.preventDefault(); go(item.t); }} style={{ color: "var(--ink)", textDecoration: "none", fontSize: 15 }}>
                      {item.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <div style={{ fontSize: 11.5, fontWeight: 600, letterSpacing: ".16em", textTransform: "uppercase", color: "var(--ink-2)", marginBottom: 20, fontFamily: "Inter, sans-serif" }}>{t("footer.groupFair")}</div>
            <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.65, color: "var(--muted)" }}>
              {t("footer.fairBlurb")} <a href="#" onClick={(e) => { e.preventDefault(); go("fair-hospitality"); }} className="ulink">{t("footer.readCommitment")} →</a>
            </p>
          </div>
        </div>

        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center", gap: 24,
          marginTop: 96,
          paddingTop: 28, borderTop: "1px solid var(--line)",
          color: "var(--muted)", fontSize: 13.5, flexWrap: "wrap"
        }}>
          <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
          <nav aria-label={t("footer.legalAria")} style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {legalLinks.map((link) => (
              <a
                key={link.route || link.action}
                href={link.route ? `/${currentLocale(i18n)}/${link.route}` : "#"}
                onClick={(e) => {
                  e.preventDefault();
                  if (link.route) go(link.route);
                  else if (link.action === "cookie-settings") {
                    window.dispatchEvent(new Event("open-cookie-settings"));
                  }
                }}
                style={legalLink}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 40px !important; }
          .footer-grid > :first-child, .footer-grid > :last-child { grid-column: span 2; }
        }
      `}</style>
    </footer>
  );
}
